import { ICellRendererParams, ISetFilterParams } from '@ag-grid-community/core'
import {
  generateMdiIcon,
  HeliosColumnTypes,
  HeliosMdiIconClass,
} from '@helios/ag-grid-config'

const booleanCellRendererCache = new Map<string, string>()

export const booleanCellRenderer = (
  params: ICellRendererParams,
  iconClass: HeliosMdiIconClass,
) => (params.value ? generateMdiIcon(iconClass) : '')

export const booleanFilterCellRenderer = (
  params: ICellRendererParams,
  iconClass: HeliosMdiIconClass,
) => {
  const cachedResult = booleanCellRendererCache.get(params.value)
  if (cachedResult != null) {
    return cachedResult
  }

  const result =
    String(params.value).toLowerCase() === 'true'
      ? `${generateMdiIcon(iconClass)} True`
      : 'False'
  booleanCellRendererCache.set(params.value, result)
  return result
}

export const getBooleanTypeCellRenderer = (iconClass: HeliosMdiIconClass) => {
  return {
    filter: 'agSetColumnFilter',
    type: HeliosColumnTypes.Boolean,
    cellRenderer: (params: ICellRendererParams) =>
      booleanCellRenderer(params, iconClass),
    filterParams: {
      refreshValuesOnOpen: true,
      cellRenderer: params => booleanFilterCellRenderer(params, iconClass),
    } as ISetFilterParams,
  }
}
